<template>
  <div :id="`trail_${trail.trailIdLabel}`" class="c-trail_item">
    <el-row :type="'flex'">
      <el-col :span="20" style="margin: auto;">
        <el-row :type="'flex'">
          <el-col :span="16" style="margin: auto;">
            <div class="cell item-name">
              <el-tooltip
                class="item"
                effect="dark"
                placement="top"
                :content="`${trail.riskLevel.label} Severity`"
                :enterable="false"
                v-if="trail.riskScore > 0"
              >
                <i v-if="trail.riskScore > 0" class="color-block" :class="`${trail.riskLevel.level}-risk-color`"></i>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" :content="`Trail ID`" placement="top" :enterable="false">
                <router-link :to="{ name: 'attack-track-details', params: { trailId: trail.id } }"
                  ><h6 class="display-inline-block">{{ trail.trailIdLabel }}</h6>
                </router-link>
              </el-tooltip>
            </div>
          </el-col>
          <el-col :span="8" style="margin: auto;">
            <el-tooltip class="item" effect="dark" :content="`Last Detection Time`" placement="top" :enterable="false">
              <span class="box subtitle2">{{ getTimeAgo(trail.lastIocSeenTime) }} ago</span>
            </el-tooltip>
          </el-col>
        </el-row>
        <el-row :type="'flex'" v-if="trail.similarFingerprintCount > 0" :gutter="44">
          <el-col :span="24" class="ml-12">
            <router-link
              :to="{
                name: 'active-cyber-attacks',
                params: { trailHashId: trail.id, trailId: trail.trailIdLabel },
                query: { date_range: 'PAST_1_MONTH', fingerprint: trail.fingerprintLabel }
              }"
              >{{ trail.similarFingerprintCount }} other similar</router-link
            >
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="4">
        <span class="box icon"></span>
        <div class="box grow flex column owner align-center">
          <el-tooltip
            class="item"
            effect="dark"
            :content="`${trail.ownerId.firstname ? trail.ownerId.fullname : 'Not Assigned'}`"
            placement="bottom"
            :enterable="false"
          >
            <user-button :classList="trail.ownerId.firstname ? 'shamrock-200' : ''" :user="trail.ownerId" />
          </el-tooltip>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import moment from 'moment-timezone'
import { DATETIME_FORMAT, NANOSECONDS_TO_MILLISECONDS } from '@/constants/datetime.constants'
import { formatFromNow } from '@/utilities/datetime.helper'
import UserButton from '@/components/button/UserButton.vue'
import CyberKillChainTickChart from '@/components/chart/CyberKillChainTickChart.vue'

export default {
  name: 'DashboardTrailInfoCard',
  props: {
    trail: {
      type: Object,
      default: () => {
        return {}
      }
    },
    showOwner: { type: Boolean, default: true },
    parent: { type: String }
  },
  data () {
    return {
      currIndex: 0,
      play: false,
      dateformat: DATETIME_FORMAT,
      cardClick: {}
    }
  },
  methods: {
    openLink () {
      this.$router.push({
        name: 'attack-track-details',
        params: { trailId: this.trail.id }
      })
    },
    getTimeAgo (val) {
      // convert startTime to ms if necessary
      if (val && !moment(val).isValid()) {
        val = val * NANOSECONDS_TO_MILLISECONDS
      }
      let agoFormat = formatFromNow(val, {
        years: { enabled: true, unit: 'y' },
        months: { enabled: true, unit: 'M' },
        days: { enabled: true, unit: 'd' },
        hours: { enabled: true, unit: 'h' },
        minutes: { enabled: true, unit: 'm' },
        seconds: { enabled: true, unit: 's' }
      })
      return agoFormat.split(' ')[0]
    }
  },
  created () {
    this.cardClick = _.debounce(event => {
      this.openLink()
    }, 250)
  },
  watch: {},
  beforeDestroy: function () {},
  components: { UserButton, CyberKillChainTickChart }
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';
@import 'assets/styles/colors.css';
@import 'assets/styles/text.css';
@import 'assets/styles/icon.css';

.c-trail_item {
  padding: 8px 8px;

  .el-divider--vertical {
    margin: 0px;
  }

  .cell {
    box-sizing: border-box;
    white-space: normal;
    word-break: break-all;
  }

  .item-name {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    h6 {
      line-height: 20px;
    }

    .el-divider--vertical {
      height: 1.25em;
    }

    .material-icons {
      font-size: 1.25em;
      color: var(--aluminum-600);
    }

    time {
      color: var(--gray-400);
      float: right;
    }

    .timestamp {
      vertical-align: text-top;
    }
  }

  .item-score {
    margin-left: 12%;

    span {
      display: block;
    }
  }

  .close-sidebar {
    font-size: 1.25em;
    line-height: 1em;
  }

  .item-summary {
    .summary-block {
      height: 16px;
      width: 16px;
      border-radius: 50%;
      margin: auto;
      margin-bottom: 4px;
    }

    span {
      text-align: center;

      &.icon-hosts {
        margin: 0px;
      }
    }
  }

  .material-icons {
    font-size: 2em;
    margin-left: 10px;
  }

  .item-expand.disabled {
    color: var(--tuna-400);
  }

  .circle {
    width: 20px;
    height: 20px;
    display: table-cell;
    border-radius: 50%;
    font-size: 10px;
    color: #fff;
    line-height: 20px;
    text-align: center;
    background: var(--primary-blue-400);
  }

  .avatar-wrapper {
    align-items: stretch;
  }

  .avatar-circle {
    color: white;
    letter-spacing: -1px;
    font-size: 13px;
    height: 32px;
    width: 32px;
    padding: 0px;
    margin: 0px;
    position: relative;
  }

  .icon-unassigned {
    width: 32px;
    height: 32px;
    margin: 0px;
    mask-size: cover;
  }

  .link {
    padding: 1px;
    margin-top: 5px;

    .icon {
      mask-size: cover;
      color: var(--aluminum-600);
    }
  }

  .material-icons.item-expand,
  .icon-trail {
    color: var(--aluminum-600);
  }
}

.c-trail_item.active {
  box-shadow: 2px 2px 12px 2px rgba(0, 0, 0, 0.1);
}

.c-trail_item:hover {
  background-color: var(--aluminum-100);
}

.active-row {
  box-shadow: 2px 2px 12px 2px rgba(0, 0, 0, 0.1);
}

>>> .column.owner {
  .el-button {
    height: 2em;
    width: 2em;
    font-size: 0.9em;
    cursor: auto;
  }
}

>>> .unassigned {
  font-size: 1.7em !important;
  cursor: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/DashboardTrailInfoCard.vue